import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';

@Injectable({
  providedIn: 'root',
})
export class TopmenuService {
  constructor(private contentful: ContentfulService) {}

  topMenuData: any;

  private topMenuSubject$ = new BehaviorSubject<any>(null);
  public topMenu$ = this.topMenuSubject$.asObservable();

  gettopMenuData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.navHeader,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as any;
        this.topMenuData = mod.filter(
          (x: Entry<any>) => x.fields?.['id'] == PageId.psHeaderNew
        );
        const topMenuData = this.topMenuData[0].fields;
        // const topMenuData = this.topMenuData;
        if (topMenuData) {
          this.topMenuSubject$.next(topMenuData);
        }
      });
  }
}
